import { Divider, Form, FormProps, Radio } from 'antd';
import Input from 'app/components/Input';
import { Title } from 'app/components/Typography/Title';
import React from 'react';
import styled from '@emotion/styled';
import FormItem from '../Form/FormItem';

const StyledForm = styled(Form)`
  width: 70vw;
  background-color: #fff;
  padding: 40px;
`;
export const INITIAL_VALUES = {
  lastName: '',
  firstName: '',
  email: '',
  role: 'inspector',
  permission: 'web_edit'
};
const CreateInspectorForm = (
  props: {
    title: string;
    initialValues: typeof INITIAL_VALUES;
  } & Pick<FormProps, 'onFinish' | 'onValuesChange'>,
  ref: any
) => {
  const [form] = Form.useForm();

  React.useImperativeHandle(ref, () => {
    return {
      ...form
    };
  });
  return (
    <StyledForm
      onFinish={props.onFinish}
      initialValues={props.initialValues}
      onValuesChange={props.onValuesChange}
      name="create-inspector"
      form={form}
      layout="vertical"
    >
      <Title level={3}>{props.title}</Title>
      <FormItem name="firstName" label="First Name">
        <Input placeholder="Enter First Name"></Input>
      </FormItem>
      <FormItem name="lastName" label="Last Name">
        <Input placeholder="Enter Last Name"></Input>
      </FormItem>
      <FormItem
        name="email"
        label="User Email"
        required
        rules={[
          { required: true, message: 'Please input your email' },
          { type: 'email', message: 'Please input a valid email' }
        ]}
      >
        <Input placeholder="Enter user email"></Input>
      </FormItem>
      <FormItem name="phone" label="Contact Number" required>
        <Input placeholder="Enter Contact Number"></Input>
      </FormItem>
      <Divider style={{ border: 'none' }}></Divider>
      <Title level={4}>Role</Title>
      <FormItem name="role">
        <Radio.Group>
          <Radio value="inspector">Inspector</Radio>
        </Radio.Group>
      </FormItem>
      <Title level={4}>Module Permission</Title>
      <FormItem name="permission" label="Inspector Web App">
        <Radio.Group>
          <Radio value="web_edit">Edit</Radio>
        </Radio.Group>
      </FormItem>
    </StyledForm>
  );
};
CreateInspectorForm.displayName = 'CreateInspectorForm';
export default React.forwardRef(CreateInspectorForm);
